import type BaseModel from "../../../src/models/BaseModel";
import ObjectFactory from "../../../src/models/ObjectFactory";
import { type C1_EloItemInstanceData, type C1_LegacyEloItemTreeData } from "../types/C1_EloTypes";
import C1_EloItem, { migrateLegacyEloItemTreeNode } from "./C1_EloItem";
import type Button from "../../../src/models/Button";

/** C1 button data attached directly to an ESTADA Button. */
export class C1_Button extends C1_EloItem {
  override get className(): string {
    return "C1_Button";
  }

  override get owner(): Button | undefined {
    return super.owner as Button | undefined;
  }

  constructor(data: C1_EloItemInstanceData, owner: BaseModel) {
    super(data, owner);
    this.fromJSON(data);
  }

  override fromJSON(input: unknown): void {
    return super.fromJSON(input);
  }

  override toJSON(): C1_EloItemInstanceData {
    return super.toJSON();
  }
}

/** Adds editor support to an existing device without recreating its channels or placement. */
export function ensureButtonEditorFacet(button: Button): C1_Button | undefined {
  if (!button.isButton) return undefined;
  if (button.c1) return button.c1.className === "C1_Button" ? button.c1 as C1_Button : undefined;
  const facet = new C1_Button({ _defId: "" }, button);
  button.c1 = facet;
  return facet;
}

ObjectFactory.registerClass(
  "c1:C1_Button",
  (data: C1_EloItemInstanceData | C1_LegacyEloItemTreeData, owner?: BaseModel) =>
    new C1_Button(migrateLegacyEloItemTreeNode(data, owner!), owner!) as unknown as BaseModel,
);
